import React, { PureComponent } from "react";
import { Modal, StatusBar, Text, TouchableOpacity, View } from "react-native";
import { Button, Spinner } from "native-base";
import Icon from "react-native-vector-icons/Ionicons";
// import Modal from 'react-native-modal';
import { withTranslation } from "react-i18next";
import { blendColor } from "../../utils/BlendColor";
import UnitService from "../../services/screens/common/UnitService";
import MessageBox from "../../components/ui/MessageBox";
import UIDs from "../../UIDs";
import * as Helper from "../../utils/Helper";

const mime = require("mime");
const uid = UIDs.components.ui.fileUploadModal;

function base64UrlToBlob(base64) {
  const arr = base64.split(',')
  const mime = arr[0].match(/:(.*?);/)[1]
  const str = atob(arr[1])
  let n = str.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = str.charCodeAt(n)
  }
  return new Blob([u8arr], { type: mime })
}

function makeThumbnail(file, maxWidth, maxHeight, mimeType) {
    return new Promise((resolve, reject) => {
        let reader = new FileReader;
        reader.onabort = function() {
            reject("read file abort");
        };
        reader.onerror = function() {
            reject("read file error");
        };
        reader.onload = function(e) {
            let img = new Image;
            img.onabort = function() {
                reject('load image abort');
            }
            img.onerror = function() {
                reject('load image error');
            }
            img.onload = function() {
                let width = img.width;
                let height = img.height;
                if (maxWidth > 0 && maxWidth < width) {
                    height = parseInt((maxWidth / width) * height);
                    width = parseInt(maxWidth);
                }

                if (maxHeight > 0 && maxHeight < height) {
                    width = parseInt((maxHeight / height) * width);
                    height = parseInt(maxHeight);
                }

                let canvas = document.createElement('canvas');
                let ctx = canvas.getContext('2d');
                canvas.width = width;
                canvas.height = height;
                ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

                let url = canvas.toDataURL((mimeType || file.type), 0.8);
                resolve(url);
            }
            img.src = e.target.result;
        };
        reader.readAsDataURL(file);
    });
}

class FileUploadModalWeb extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            uploading: false,
            error: null,
            name: "",
            response: null,
        };
    }

    componentDidMount() {}

    componentWillUnmount() {}

    addFile(key) {
        if (this._pendingUpload !== undefined) {
            return;
        }

        this._pendingKey = key;
        this.setState({ visible: true, uploading: false });
    }

    takePhoto(key) {
        if (this._pendingUpload !== undefined) {
            return;
        }

        const options = {
            //quality: 1.0,
            //maxWidth: 500,
            //maxHeight: 500,
            noData: true,
            storageOptions: {
                skipBackup: true,
                waitUntilSaved: true,
            },
        };

        // launchCamera(options, (response) => {
        //     if (this._pendingUpload !== undefined) {
        //         return;
        //     }
        //
        //     if (response.didCancel) {
        //         console.log("User cancelled photo picker");
        //     } else if (response.errorMessage) {
        //         MessageBox.danger(response.errorMessage);
        //     } else {
        //         response = response.assets ? response.assets[0] : {};
        //         this._addUpload(key, {uri: response.uri,
        //                               type: response.type,
        //                               name: response.fileName,
        //                               size: response.fileSize});
        //     }
        // });
    }

    pickPhoto(info, key) {
        if (this._pendingUpload !== undefined) {
            return;
        }

        if (this.imageInput) {
            this.imageInput.click();
        }
    }

    pickFile(key) {
        if (this._pendingUpload !== undefined) {
            return;
        }
        if (this.fileInput) {
            this.fileInput.click();
        }
    }

    handleFileChange(event, key) {
        const fileObject = event.target.files[0];
        if (!fileObject) {return;}
        const response = fileObject;
        makeThumbnail(response, 1000, 1000, 'image/jpeg').then((url) => {
            const blob = base64UrlToBlob(url);
            const file = new File([blob], response.name, { type: blob.type });
            this._addUpload(key, { file: file, type: blob.type, name: response.name, size: blob.size });
        }).catch((msg) => alert(msg));
    }

    handleImageChange(event, key) {
        const fileObject = event.target.files[0];
        if (!fileObject) {return;}
        const response = fileObject;
        makeThumbnail(response, 1000, 1000, 'image/jpeg').then((url) => {
            const blob = base64UrlToBlob(url);
            const file = new File([blob], response.name, { type: blob.type });
            this._addUpload(key, { file: file, type: blob.type, name: response.name, size: blob.size });
        }).catch((msg) => alert(msg));
    }

    _addUpload(key, res) {
        let i;
        if (this.props.maxFileSize && res.size > this.props.maxFileSize) {
            MessageBox.danger(this.props.t("tooLargeFile"));
            return;
        }

        let name = res.name;
        if (!name) {
            return;
        }

        let suffix = "";
        i = name.lastIndexOf(".");
        if (i > 0) {
            suffix = name.substring(i);
        }

        if (!suffix && res.type) {
            const ext = mime.getExtension(res.type);
            if (ext) {
                suffix = "." + ext;
                name += suffix;
            }
        }

        this._currentFile = { ...res, name: name };
        this._pendingUpload = key;
        this._uploadFile();
    }

    _uploadFile = () => {
        const pendingUpload = this._pendingUpload;
        const currentFile = this._currentFile;
        const fileUri = currentFile.file;
        const name = currentFile.name;
        const fileZ = fileUri;
        this.setState({ visible: true, uploading: true, error: null, name: name, response: null });
        UnitService.uploadFileImmediately(
            this.props.ownerId,
            this.props.ownerType,
            this.props.unitId,
            fileZ,
            fileResponse => {
                // if (this._pendingUpload === undefined) {
                //     return;
                // }
                if (this._pendingUpload !== pendingUpload) {
                    return;
                }
                if (this._currentFile !== currentFile) {
                    return;
                }

                this.setState({ response: fileResponse, error: null });
                if (this.props.onUpload) {
                    this.props.onUpload(this._pendingUpload, this._currentFile, fileResponse);
                }
            },
            err => {
                console.warn("uploadFileImmediately error:", err);
                if (err && err.message) {
                    this.setState({ error: err.message });
                }
            }
        );
    };

    _handleClose = () => {
        delete this._pendingUpload;
        delete this._currentFile;
        this.setState({ visible: false, uploading: false, error: null, name: "", response: null });
    };

    renderError() {
        return <Text style={{ fontSize: 14, marginTop: 20, color: "#c00" }}>{this.state.error}</Text>;
    }

    renderProgress() {
        return (
            <View style={{ flexDirection: "row", alignItems: "center", marginTop: 20 }}>
                <Spinner />
                <Text style={{ marginLeft: 8, fontSize: 14, color: "#666" }}>{this.props.t("uploading")}</Text>
            </View>
        );
    }

    renderSuccess() {
        return <Text style={{ fontSize: 14, marginTop: 20, color: "#00cc00" }}>{this.props.t("uploadSuccess")}</Text>;
    }

    renderPick() {
        const screenWidth = Helper.getContainerSize().width;
        return (
            <View style={{flex:1, backgroundColor: 'rgba(0, 0, 0, 0.7)',}}>
            <View style={{ width: screenWidth * 0.9, paddingLeft: 20, paddingRight: 20, paddingTop: 4, paddingBottom: 20, flexDirection: "column", borderRadius: 10, backgroundColor: "#fff", margin:"auto" }}>
                <View style={{ zIndex: 1, flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }} />
                    <TouchableOpacity
                        onPress={() => {
                            this._handleClose();
                        }}>
                        <Icon name="ios-close" style={{ fontSize: 46, color: "#999999", marginRight: 0 }} />
                    </TouchableOpacity>
                </View>
                <View style={{ flexDirection: "column", alignItems: "center", marginTop: -30 }}>
                    <Text style={{ fontSize: 18, fontWeight: "bold" }}>{this.props.t("fileUpload")}</Text>
                </View>
                <View style={{ flexDirection: "column", alignItems: "center", marginTop: 20 }}>
                    {/*<Button style={{width: '80%', height: 40, backgroundColor: "#1E90FF",
                                        borderRadius: 20, alignItems: 'center', justifyContent: 'center'}}
                                transparent onPress={() => {
                                    this.takePhoto(this._pendingKey);
                                }}>
                            <Text style={{color: '#fff'}}>{this.props.t('takePhoto')}</Text>
                        </Button>*/}
                    <input ref={fileInput => (this.fileInput = fileInput)} type="file" style={{ display: "none" }} onChange={e => this.handleFileChange(e, this._pendingKey)} />
                    <Button
                        style={{ width: "80%", height: 40, backgroundColor: "#1E90FF", marginTop: 8, borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                        transparent
                        onPress={() => {
                            this.pickPhoto(this._pendingKey);
                        }}>
                        <Text style={{ color: "#fff" }}>{this.props.t("pickPhoto")}</Text>
                    </Button>
                    <input ref={fileInput => (this.imageInput = fileInput)} type="file" accept="image/*" style={{ display: "none" }} onChange={e => this.handleImageChange(e, this._pendingKey)} />
                    {
                        this.props.imageOnly ? null : <Button
                            style={{ width: "80%", height: 40, backgroundColor: "#1E90FF", marginTop: 8, borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                            transparent
                            onPress={() => {
                                this.pickFile(this._pendingKey);
                            }}>
                            <Text style={{ color: "#fff" }}>{this.props.t("pickFile")}</Text>
                        </Button>
                    }
                </View>
            </View>
            </View>
        );
    }

    renderUpload() {
        const screenWidth = Helper.getContainerSize().width;
        return (
            <View style={{flex:1, backgroundColor: 'rgba(0, 0, 0, 0.7)',}}>
            <View style={{ width: screenWidth * 0.9, paddingLeft: 20, paddingRight: 20, paddingTop: 4, paddingBottom: 20, flexDirection: "column", borderRadius: 10, backgroundColor: "#fff", margin:"auto" }}>
                <View style={{ zIndex: 1, flexDirection: "row", alignItems: "center" }}>
                    <View style={{ flex: 1 }} />
                    <TouchableOpacity
                        onPress={() => {
                            this._handleClose();
                        }}>
                        <Icon name="ios-close" style={{ fontSize: 46, color: "#999999", marginRight: 0 }} />
                    </TouchableOpacity>
                </View>
                <View style={{ flexDirection: "column", alignItems: "center", marginTop: -30 }}>
                    <Text style={{ fontSize: 18, fontWeight: "bold" }}>{this.props.t("fileUpload")}</Text>
                    <Text style={{ fontSize: 14, marginTop: 20, color: "#666" }}>{this.state.name}</Text>
                    {this.state.error ? this.renderError() : this.state.response ? this.renderSuccess() : this.renderProgress()}
                </View>
                <View style={{ flexDirection: "row", marginTop: 20 }}>
                    {this.state.error ? (
                        <Button
                            style={{ flex: 1, height: 40, backgroundColor: "#1E90FF", borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                            transparent
                            onPress={() => {
                                this._uploadFile();
                            }}>
                            <Text style={{ color: "#fff" }}>{this.props.t("retry")}</Text>
                        </Button>
                    ) : this.state.response ? (
                        <Button
                            style={{ flex: 1, height: 40, backgroundColor: "#1E90FF", borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                            transparent
                            onPress={() => {
                                this._handleClose();
                            }}>
                            <Text style={{ color: "#fff" }}>{this.props.t("ok")}</Text>
                        </Button>
                    ) : (
                        <Button
                            style={{ flex: 1, height: 40, backgroundColor: "#1E90FF", borderRadius: 20, alignItems: "center", justifyContent: "center" }}
                            transparent
                            onPress={() => {
                                this._handleClose();
                            }}>
                            <Text style={{ color: "#fff" }}>{this.props.t("cancel")}</Text>
                        </Button>
                    )}
                </View>
            </View>
            </View>
        );
    }

    render() {
        return (
            <Modal
                visible={this.state.visible}
                transparent={true}
                avoidKeyboard={true}
                style={{ alignItems: "center", justifyContent: "center", zIndex: 100 }}
                onBackButtonPress={() => {}}
                onBackdropPress={() => {}}>
                {this.props.barColor ? <StatusBar barStyle={this.props.barStyle} backgroundColor={blendColor(this.props.barColor, "rgba(0,0,0,0.4)")} /> : null}
                {this.state.uploading ? this.renderUpload() : this.renderPick()}
            </Modal>
        );
    }
}

export default withTranslation(uid, { withRef: true })(FileUploadModalWeb);
